export enum FileSummaryType {
    ERROR = 1,
    NEW = 2,
    UPDATE = 3,
    GENERAL = 4,
    INVALID_FILE = 5,
    TOTAL = 6,
    UNDEFINED = 7
}
